import React from "react";
import About from "./About";
import Teams from "../Teams/Teams";
import Footer from "../Footer/Footer";
import DonationPage from "../Donation/DonationPage";

function AboutUs() {
  return (
    <>
        <About />
        <Teams />
        <DonationPage />
        <Footer />
    </>
  );
}

export default AboutUs;
